import { BiVizType } from '@euler/model/bi/viz';
import {
  BiGalleryCategory,
  BiGalleryCategoryKey,
  BiGalleryDashboardCard,
} from '../functions/biGalleryTypes';
import {
  cents,
  kGalleryFields as f,
  galleryReady,
  galleryResult,
  kGalleryLongItems,
} from './biGalleryFields';

const technicians: [string, number][] = [
  ['王建国', 86420],
  ['李晓明', 79310],
  ['张伟', 71860],
  ['刘洋', 66240],
  ['陈志强', 58930],
  ['杨帆', 51270],
  ['赵磊', 46810],
  ['黄海涛', 39550],
  ['周俊', 33120],
  ['吴昊', 27480],
];
const items = [96800, 88400, 71300, 64900, 52600, 41200];
const brands: [string, number][] = [
  ['梅赛德斯-奔驰', 12345678.9],
  ['宝马', 10987654.3],
  ['奥迪', 9876543.21],
  ['保时捷', 8123456.78],
  ['雷克萨斯', 6543210.5],
];

const ranking: BiGalleryDashboardCard = {
  surface: 'dashboard',
  title: '本月技师营收排行',
  viz: {
    type: BiVizType.HorizontalBar,
    x: f.technician.key,
    series: [{ key: f.revenue.key }],
  },
  data: galleryReady(
    galleryResult(
      [f.technician, f.revenue],
      technicians.map(([name, yuan]) => [name, cents(yuan)]),
    ),
  ),
  rows: 5,
};

export const kHorizontalBarCategory: BiGalleryCategory = {
  key: BiGalleryCategoryKey.HorizontalBar,
  name: '条形图',
  description: '排行、长名称、8 位金额',
  preview: ranking,
  variants: [
    { key: 'ranking', name: '排行', note: '按营收降序 10 名', card: ranking },
    {
      key: 'ranking-labels',
      name: '排行 · 数据标签',
      note: 'dataLabels = true',
      card: {
        ...ranking,
        viz: { ...ranking.viz, style: { dataLabels: true } },
      },
    },
    {
      key: 'long-labels',
      name: '长名称',
      note: '名称在左侧，过长截断',
      card: {
        surface: 'dashboard',
        title: '服务项目营收',
        viz: {
          type: BiVizType.HorizontalBar,
          x: f.item.key,
          series: [{ key: f.revenue.key }],
          style: { dataLabels: true },
        },
        data: galleryReady(
          galleryResult(
            [f.item, f.revenue],
            kGalleryLongItems.map((item, i) => [item, cents(items[i])]),
          ),
        ),
      },
    },
    {
      key: 'big-amounts',
      name: '8 位金额',
      note: '千万级营收，带数据标签',
      card: {
        surface: 'dashboard',
        title: '年度各品牌营收',
        viz: {
          type: BiVizType.HorizontalBar,
          x: f.brand.key,
          series: [{ key: f.revenue.key }],
          style: { dataLabels: true },
        },
        data: galleryReady(
          galleryResult(
            [f.brand, f.revenue],
            brands.map(([brand, yuan]) => [brand, cents(yuan)]),
          ),
        ),
      },
    },
    {
      key: 'two-measures',
      name: '两个指标',
      note: '配件与工时营收',
      card: {
        surface: 'dashboard',
        title: '技师营收构成',
        viz: {
          type: BiVizType.HorizontalBar,
          x: f.technician.key,
          series: [{ key: f.partsRevenue.key }, { key: f.laborRevenue.key }],
        },
        data: galleryReady(
          galleryResult(
            [f.technician, f.partsRevenue, f.laborRevenue],
            technicians
              .slice(0, 6)
              .map(([name, yuan]) => [
                name,
                cents(yuan * 0.62),
                cents(yuan * 0.38),
              ]),
          ),
        ),
        rows: 5,
      },
    },
  ],
};
